import type { PartnerConfig } from "@/content/partners/types"

export const PORTAL_CAMINHO_DAS_MONTANHAS_PARTNER_SLUG = "portal-caminho-das-montanhas"

export const PORTAL_CAMINHO_DAS_MONTANHAS_LOGO_PATH =
  "/partners/portal-caminho-das-montanhas/logo.png"

/**
 * Código de carteira da Victória de Fátima Guilherme Carvalho Pereira em produção
 * (`profiles.id` `501f4851-2578-445a-80ea-408d6d53e7ff`, `seller_referral_codes.code`).
 * Staging pode não ter o perfil — o signup ignora código inexistente sem bloquear o cadastro.
 */
export const PORTAL_CAMINHO_DAS_MONTANHAS_PORTFOLIO_SELLER_CODE = "VDY2ZH3V"

/** Verde-escuro e creme do logo — só kicker/anel; CTAs ficam Action-Blue. */
export const portalCaminhoDasMontanhasBrand = {
  accent: "#143D28",
  accentDark: "#0C2818",
  accentLight: "#E8D5A3",
  navy: "#143D28",
  ringFrom: "#E8D5A3",
  ringTo: "#143D28",
  benefit: "#143D28",
  benefitForeground: "#F3E6C4",
} as const

export const portalCaminhoDasMontanhasPartnerConfig: PartnerConfig = {
  slug: PORTAL_CAMINHO_DAS_MONTANHAS_PARTNER_SLUG,
  name: "Portal Caminho das Montanhas",
  fullName: "Condomínio Portal Caminho das Montanhas",
  logoPath: PORTAL_CAMINHO_DAS_MONTANHAS_LOGO_PATH,
  benefitMode: "percent_increment",
  benefitPercentIncrement: 5,
  isActive: true,
  forcedSellerReferralCode: PORTAL_CAMINHO_DAS_MONTANHAS_PORTFOLIO_SELLER_CODE,
  metadata: {
    industry: "condominio",
    portfolio_seller_name: "Victória de Fátima Guilherme Carvalho Pereira",
  },
}

export const portalCaminhoDasMontanhasPartnerContent = {
  ...portalCaminhoDasMontanhasPartnerConfig,
  tagline: "Condomínio Portal Caminho das Montanhas",
  benefitHeadline: "Benefício para moradores",
  heroHeadline:
    "Moradores do Condomínio Portal Caminho das Montanhas têm desconto extra na energia",
  heroSubtitle:
    "Economize até 30% do total da sua conta de luz com a energia solar por assinatura da Astra.",
  partnershipIntro:
    "Moradores do Condomínio Portal Caminho das Montanhas têm 5% a mais de desconto na energia por assinatura do que sem a parceria. Cadastro simples, benefício automático por este link.",
  partnershipTitle: "Condomínio Portal Caminho das Montanhas e energia limpa, juntos",
} as const
